/* eslint-disable jsx-a11y/alt-text */
import React, { useEffect, useRef, useState } from "react";
import { AiOutlinePlus } from "react-icons/ai";
import { useNavigate, useParams } from "react-router-dom";
import { uploadImage } from "../../../../api/helper/upload-image";
import { useProductGroupCategory } from "../../../../api/product-group-category/use-product-group-category";
import { useUpdateProductGroup } from "../../../../api/product-group/use-product-group";
import { useProductGroupById } from "../../../../api/product-group/use-product-group-detail";
import TitlePage from "../../../../components/section/TitlePage/Titlepage";
import Button from "../../../../components/ui/Button/Button";
import Card from "../../../../components/ui/Card/Card";
import { Dropdown } from "../../../../components/ui/Dropdown/Dropdown";
import InputDate from "../../../../components/ui/InputDate/InputDate";
import Modal from "../../../../components/ui/Modal/Modal";
import Editor from "../../../../components/Editor";
import { Form } from "../../../../utils/Form/Form";
import { FieldInput } from "../../../../utils/Form/Input";
import { FieldRadio } from "../../../../utils/Form/Radio";
import FieldBox from "../../../../utils/Form/ui/FieldBox";
import ProductList from "./Section/ProductListTable";
import { formatPrice } from "../../../../utils";
import dayjs from "dayjs";

const ProductGroupEditPage = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const { data } = useProductGroupById(id);
  const defaultValues = data?.data;
  const mainImageRef = useRef(null);
  const moreImageRef = useRef(null);
  const quillRef = useRef(null);
  const { data: categories } = useProductGroupCategory();
  const { mutate: updateProductGroup } = useUpdateProductGroup();
  // const { mutate: deleteProductGroup } = useDeleteProductGroup();
  const [selectedCategory, setSelectedCategory] = useState(
    defaultValues?.productGroupCategoryId
  );
  const [productName, setProductName] = useState("");
  const [productRef, setProductRef] = useState("");
  const [keyword, setKeyword] = useState("");
  const [keywords, setKeywords] = useState(defaultValues?.keywords);
  const [entryProduct, setEntryProduct] = useState({
    name: "",
    ref: "",
    saleStatus: "SALE",
  });
  const [productColorStatus, setProductColorStatus] = useState("");
  const [productList, setProductList] = useState(defaultValues?.products);
  const [selectedProducts, setSelectedProducts] = useState([]);
  const [mainImage, setMainImage] = useState(defaultValues?.mainImage);
  const [moreImages, setMoreImages] = useState(defaultValues?.additionalImages);
  const [deliveryTypeValue, setDeliveryTypeValue] = useState(
    defaultValues?.deliveryType
  );
  const [refundTypeValue, setRefundTypeValue] = useState(
    defaultValues?.refundType
  );
  const [deliveryFee, setDeliveryFee] = useState(defaultValues?.deliveryFee);
  const [refundPrice1, setRefundPrice1] = useState(defaultValues?.refundPrice1);
  const [refundPrice2, setRefundPrice2] = useState(defaultValues?.refundPrice2);

  const [discountStartDate, setDiscountStartDate] = useState(
    defaultValues?.discountStartDate
      ? dayjs(defaultValues?.discountStartDate)
      : null
  );
  const [discountEndDate, setDiscountEndDate] = useState(
    defaultValues?.discountEndDate
      ? dayjs(defaultValues?.discountEndDate)
      : null
  );
  const [isPointPurchase, setIsPointPurchase] = useState(
    defaultValues?.pointPurchasePercent ? true : false
  );
  const [isPointReview, setIsPointReview] = useState(
    defaultValues?.pointReview ? true : false
  );
  const [lengthOptions, setLenghtOptions] = useState([
    "8.5",
    "10.0",
    "11.5",
    "13.0",
    "15.0",
  ]);
  const [selectedDateOption, setSelectedDateOption] = useState();

  const onChangeDiscountStartDate = (value) => {
    setDiscountStartDate(value);
  };

  const onChangeDiscountEndDate = (value) => {
    setDiscountEndDate(value);
  };

  const onChangeCategory = (id) => {
    setSelectedCategory(id);

    if (id !== "3db02ee9-47e8-4c2a-8cae-af8af80cad29") {
      setProductColorStatus("0");
      setEntryProduct({
        ...entryProduct,
        width: null,
        length: null,
      });
    }
    if (id === "") {
      setProductColorStatus("");
    }
  };

  useEffect(() => {
    const productValue = entryProduct.width;
    if (productValue === "3" || productValue === "3.3") {
      setLenghtOptions(["8.5", "10.0", "11.5", "13.0", "15.0"]);
    }
    if (
      productValue === "3.8" ||
      productValue === "4" ||
      productValue === "4.5" ||
      productValue === "5"
    ) {
      setLenghtOptions(["7.0", "8.5", "10.0", "11.5", "13.0", "15.0"]);
    }
    if (productValue === "5.5") {
      setLenghtOptions(["7.0", "8.5", "10.0", "11.5"]);
    }
    if (productValue === "6" || productValue === "7") {
      setLenghtOptions(["7.0", "8.5", "10.0"]);
    }
  }, [entryProduct.width]);

  const onChangeDeliveryType = (e) => {
    setDeliveryTypeValue(e.target.value);
    if (e.target.value === "FREE") {
      setDeliveryFee(0);
    }
  };

  const onChangeDeliveryFee = (e) => {
    setDeliveryFee(e.target.value);
  };

  const onChangeRefundType = (e) => {
    setRefundTypeValue(e.target.value);
    if (e.target.value === "FREE") {
      setRefundPrice1(0);
      setRefundPrice2(0);
    }
  };

  const onChangeRefundPrice1 = (e) => {
    setRefundPrice1(e.target.value);
  };

  const onChangeRefundPrice2 = (e) => {
    setRefundPrice2(e.target.value);
  };

  const onChangePointPurchase = () => {
    setIsPointPurchase(!isPointPurchase);
  };

  const onChangePointReview = () => {
    setIsPointReview(!isPointReview);
  };

  const handleImageUpload = async (event) => {
    const file = event.target.files[0];

    const imageData = new FormData();
    imageData.append("file", file);
    const { data: image } = await uploadImage(imageData);

    setMainImage(image?.publicUrl);
  };
  const handleMoreImageUpload = async (event) => {
    const file = event.target.files[0];

    const moreImageData = new FormData();
    moreImageData.append("file", file);

    const { data: image } = await uploadImage(moreImageData);

    setMoreImages([...moreImages, image?.publicUrl]);
  };

  const handleRemoveImage = () => {
    setMainImage("");
    mainImageRef.current.value = "";
  };

  const handleRemoveMoreImage = (val) => {
    const index = moreImages.indexOf(val);
    if (index > -1) {
      moreImages.splice(index, 1);
      setMoreImages([...moreImages]);
      moreImageRef.current.value = "";
    }
  };

  const onChangeKeyword = (e) => {
    setKeyword(e.target.value);
  };

  const onAddKeyword = () => {
    if (keyword !== "") {
      setKeywords([...keywords, keyword]);
      setKeyword("");
    }
  };

  const onRemoveKeyword = (val) => {
    const index = keywords.indexOf(val);
    if (index > -1) {
      keywords.splice(index, 1);
      setKeywords([...keywords]);
    }
  };

  const handleChangeProduct = (e, param) => {
    const value = e.target.value;
    setEntryProduct({
      ...entryProduct,
      [param]: value,
    });
    if (param === "name") {
      setProductName(value);
    }
    if (param === "ref") {
      setProductRef(value);
    }
  };

  const handleAddProductItem = (e) => {
    e.preventDefault();
    setProductList([...productList, entryProduct]);
    setEntryProduct({});
    setProductName("");
    setProductRef("");
    setProductColorStatus(null);
  };

  const onChangeProductColorStatus = (e) => {
    setProductColorStatus(e.target.value);
    if (e.target.value === "1") {
      setEntryProduct({
        ...entryProduct,
        width: "3",
        length: "8.5",
      });
    } else {
      setEntryProduct({
        ...entryProduct,
        width: null,
        length: null,
      });
    }
  };

  const handleSelectProduct = (refProduct) => {
    const index = selectedProducts.indexOf(refProduct);

    if (!selectedProducts.includes(refProduct)) {
      setSelectedProducts([...selectedProducts, refProduct]);
    }
    if (index > -1) {
      selectedProducts.splice(index, 1);
      setSelectedProducts([...selectedProducts]);
    }
  };

  const handleDeleteProduct = (selectedProducts) => {
    const currentlySelected = [...selectedProducts];
    const newProductList = productList.filter(
      (val) => !currentlySelected.includes(val.ref)
    );
    setProductList(newProductList);
  };

  const handleSelectAll = () => {
    const allProductRefs = productList?.map((val) => val.ref);
    if (selectedProducts !== allProductRefs) {
      setSelectedProducts(allProductRefs);
    }
    if (JSON.stringify(selectedProducts) === JSON.stringify(allProductRefs)) {
      setSelectedProducts([]);
    }
  };

  const handleSubmitEdit = async (data) => {
    const payload = {
      ...data,
      productGroupCategoryId: selectedCategory,
      mainImage: mainImage,
      additionalImages: moreImages,
      keywords: keywords,
      products: productList?.map(({ color, qr, qrQty, updatedAt, ...rest }) => {
        return {
          ...rest,
          discountRate: parseFloat(rest.discountRate).toFixed(1),
          color: color ?? "",
        };
      }),
      description: JSON.stringify(quillRef.current?.getContents()),
      deliveryFee: deliveryTypeValue !== "PAID" ? 0 : parseInt(deliveryFee),
      pointPurchasePercent: data?.pointPurchasePercent ?? 0,
      pointReview: data?.pointReview ?? 0,
      // discountStartDate: Math.round(new Date(discountStartDate) / 1000),
      // discountEndDate: Math.round(new Date(discountEndDate) / 1000),
      discountStartDate: discountStartDate?.toDate() ?? undefined,
      discountEndDate: discountEndDate?.toDate() ?? undefined,
      deliveryType: deliveryTypeValue,
      refundType: refundTypeValue,
      refundPrice1: refundTypeValue !== "PAID" ? 0 : parseInt(refundPrice1),
      refundPrice2: refundTypeValue !== "PAID" ? 0 : parseInt(refundPrice2),
    };

    try {
      await updateProductGroup({
        ...payload,
        id,
      });
    } catch (error) {}
  };

  const handleChangeProductInsideTable = (e, nameForm, refId) => {
    const objIndex = productList.findIndex((obj) => obj.ref === refId);
    if (objIndex === -1) return;

    const nextValue =
      e.target.type === "checkbox" ? e.target.checked : e.target.value;
    productList[objIndex][nameForm] = nextValue;
    const oriPrice = productList[objIndex]["oriPrice"];
    const discount = productList[objIndex]["discountRate"];
    const courting = parseInt(oriPrice) * (parseInt(discount) / 100);
    const priceAfterDisc = parseInt(oriPrice) - courting;

    productList[objIndex].price = priceAfterDisc?.toString();
  };

  // Delete product feature not available yet
  // const handleDeleteProductGroup = async () => {
  //   await deleteProductGroup(id);
  // };

  const handleCancelEdit = () => {
    navigate("/product-management/product-group");
  };

  const onChangeDateTo = (increment) => {
    if (discountStartDate !== null) {
      setSelectedDateOption(increment);
      if (increment === 1 || increment === 7) {
        const added = discountStartDate.add(increment, "day");
        setDiscountEndDate(added);
      }
      if (increment === 30) {
        const added = discountStartDate.add(1, "month");
        setDiscountEndDate(added);
      }
      if (increment === 90) {
        const added = discountStartDate.add(3, "month");
        setDiscountEndDate(added);
      }
    }
  };

  return (
    <div>
      <TitlePage title="상품조회 > 상품정보 상세 > 상품정보 변경" />
      <Form
        options={{
          defaultValues: defaultValues,
        }}
        onSubmit={handleSubmitEdit}
      >
        {({ register, watch, setValue }) => {
          const formValues = watch();
          const checkIsEmpty = (obj) =>
            Object.values(obj).every((val) => val === null || val === "");

          const formEmpty = checkIsEmpty(formValues);
          const productFullFilled =
            Object.values(entryProduct).every((val) => val !== "") &&
            productColorStatus !== "";

          return (
            <>
              <ol className="mt-5">
                <li>
                  <h2 className="font-bold text-[14px]">
                    1. 상품 그룹의 노출 및 판매 상태
                  </h2>
                  <Card className="mt-3">
                    <div className="flex items-center justify-between">
                      <div className="flex items-center">
                        <div className="w-32">노출 상태</div>
                        <div className="flex gap-8">
                          <FieldRadio
                            value="ON"
                            label="Y"
                            id="y"
                            registration={register("status")}
                          />

                          <FieldRadio
                            value="OFF"
                            label="N"
                            id="n"
                            registration={register("status")}
                          />
                        </div>
                      </div>
                      <div>
                        <span className="text-[#767676]">
                          ※ 노출 상태 : 카테고리 상품 목록에서 표시 (Y) /
                          목록에서 제외 (N)
                        </span>
                      </div>
                    </div>
                    <div className="flex items-center mt-4">
                      <div className="w-32">판매 상태</div>
                      <div className="flex gap-8">
                        <FieldRadio
                          value="SALE"
                          label="정상"
                          id="정상"
                          registration={register("saleStatus")}
                        />

                        <FieldRadio
                          value="NOT_SALE"
                          label="판매종료 (노출상태 N과 동일하게 카테고리 상품 목록에서 제외)"
                          id="판매종료 (노출상태 N과 동일하게 카테고리 상품 목록에서 제외)"
                          registration={register("saleStatus")}
                        />
                      </div>
                    </div>
                  </Card>
                </li>
                <li className="mt-6">
                  <h2 className="font-bold text-[14px] mb-3">
                    2. [공통] 기본 정보
                  </h2>
                  <FieldBox label="상품번호">
                    <FieldInput
                      placeholder="ONEDAY Mall에서 상품그룹 등록시 관리하기위한 상품번호를 입력해주세요 (REF 상품코드와 다름)"
                      registration={register("productNo")}
                    />
                  </FieldBox>

                  <FieldBox label="상품 그룹명">
                    <FieldInput
                      placeholder="공백포함 65자 이내로 입력해주세요"
                      registration={register("name")}
                    />
                  </FieldBox>

                  <FieldBox label="간략 설명">
                    <FieldInput
                      placeholder="공백포함 65자 이내로 입력해주세요"
                      registration={register("descriptionShort")}
                    />
                  </FieldBox>

                  <FieldBox label="검색어">
                    <div className="flex gap-2 mb-2">
                      <div className="w-48">
                        <input
                          className="border rounded-[4px] w-full h-10 text-[10px] p-2"
                          placeholder="검색어를 입력하고 등록해주세요"
                          onChange={onChangeKeyword}
                          value={keyword}
                        />
                      </div>
                      <div className="flex">
                        <Button
                          onClick={onAddKeyword}
                          isDisabled={keyword === ""}
                          className="h-10"
                          primary
                          text="검색어 등록"
                        />
                        <p className="text-[13px] text-[#707070]">
                          ※ 검색어는 최대 5개까지 등록 가능합니다.
                        </p>
                      </div>
                    </div>
                    <div className="flex items-center gap-1">
                      {keywords?.map((val) => {
                        return (
                          <div
                            key={val}
                            className="flex gap-1 border border-[#0070ef] rounded-[4px] p-2"
                          >
                            {val}
                            <div
                              className="cursor-pointer"
                              onClick={() => onRemoveKeyword(val)}
                            >
                              X
                            </div>
                          </div>
                        );
                      })}
                    </div>
                  </FieldBox>

                  <FieldBox label="카테고리">
                    <div className="w-32">
                      <Dropdown
                        width="w-32"
                        options={categories}
                        onClickItem={(id) => onChangeCategory(id)}
                        defaultValue={defaultValues?.productGroupCategoryId}
                      />
                    </div>
                  </FieldBox>

                  <FieldBox label="할인">
                    <div className="flex gap-1">
                      <div className="flex items-center gap-3 w-[40%]">
                        <FieldRadio
                          value="OFF"
                          label="할인 미적용"
                          id="할인 미적용"
                          registration={register("discountStatus")}
                        />

                        <FieldRadio
                          value="EVERY"
                          label="전체기간 할인"
                          id="전체기간 할인"
                          registration={register("discountStatus")}
                        />

                        <FieldRadio
                          value="DATES"
                          label="특정기간만 할인"
                          id="특정기간만 할인"
                          registration={register("discountStatus")}
                        />
                      </div>
                      <div className="flex gap-8 items-center">
                        <div className="flex items-center gap-3">
                          <InputDate
                            disabled={formValues?.discountStatus !== "DATES"}
                            value={discountStartDate}
                            name="discountStartDate"
                            onChange={onChangeDiscountStartDate}
                          />
                          {" - "}
                          <InputDate
                            disabled={formValues?.discountStatus !== "DATES"}
                            value={discountEndDate}
                            name="discountEndDate"
                            onChange={onChangeDiscountEndDate}
                          />
                          <div
                            className={`border h-8 rounded-[4px] border-button-grey flex divide-x text-[#bbbbbb] ${
                              formValues?.discountStartDate === undefined
                                ? "cursor-not-allowed"
                                : ""
                            }`}
                          >
                            <div
                              onClick={() => onChangeDateTo(1)}
                              className={`${
                                selectedDateOption === 1
                                  ? "bg-primary-blue text-white rounded-l-[4px]"
                                  : ""
                              } p-2 flex items-center cursor-pointer ${
                                formValues.discountStartDate === undefined
                                  ? "cursor-not-allowed"
                                  : " cursor-pointer"
                              }`}
                            >
                              오늘
                            </div>
                            <div
                              onClick={() => onChangeDateTo(7)}
                              className={`${
                                selectedDateOption === 7
                                  ? "bg-primary-blue text-white"
                                  : ""
                              } p-2 flex items-center cursor-pointer ${
                                formValues.discountStartDate === undefined
                                  ? "cursor-not-allowed"
                                  : " cursor-pointer"
                              }`}
                            >
                              7일
                            </div>
                            <div
                              onClick={() => onChangeDateTo(30)}
                              className={`${
                                selectedDateOption === 30
                                  ? "text-white bg-primary-blue"
                                  : ""
                              } p-2 flex items-center cursor-pointer ${
                                formValues.discountStartDate === undefined
                                  ? "cursor-not-allowed"
                                  : " cursor-pointer"
                              }`}
                            >
                              1개월
                            </div>
                            <div
                              onClick={() => onChangeDateTo(90)}
                              className={`${
                                selectedDateOption === 90
                                  ? "text-white bg-primary-blue"
                                  : ""
                              } p-2 flex items-center cursor-pointer ${
                                formValues.discountStartDate === undefined
                                  ? "cursor-not-allowed"
                                  : " cursor-pointer"
                              }`}
                            >
                              3개월
                            </div>
                          </div>
                        </div>
                        <span className="flex-1 text-[#707070]">
                          ※ '할인 미적용'일 경우, 개별 상품의 판매가는 정상
                          판매가로 적용됩니다.
                        </span>
                      </div>
                    </div>
                  </FieldBox>
                  <FieldBox label="적립 포인트" isLast>
                    <div className="flex items-center gap-20">
                      <div className="flex items-center gap-4">
                        <div className="flex items-center gap-1">
                          <input
                            checked={isPointPurchase}
                            onChange={onChangePointPurchase}
                            id="pointPurchasePercent"
                            type="checkbox"
                            className="accent-[#0f1e3d]"
                          />
                          <label htmlFor="pointPurchasePercent">
                            결제금액의
                          </label>
                        </div>
                        <div className="flex rounded-[4px]">
                          <input
                            className="w-24 p-1 rounded-l-[2px] border border-grey-button [appearance:textfield] [&::-webkit-outer-spin-button]:appearance-none [&::-webkit-inner-spin-button]:appearance-none"
                            type="number"
                            placeholder="0"
                            disabled={!isPointPurchase}
                            {...register("pointPurchasePercent")}
                          />
                          <div className="rounded-r-[2px] border border-grey-button p-1">
                            %
                          </div>
                        </div>
                      </div>
                      <div className="flex items-center gap-4">
                        <div className="flex items-center gap-1">
                          <input
                            checked={isPointReview}
                            onChange={onChangePointReview}
                            id="pointReview"
                            type="checkbox"
                            className="accent-[#0f1e3d]"
                          />
                          <label htmlFor="pointReview">리뷰작성시</label>
                        </div>
                        <div className="flex rounded-[4px]">
                          <input
                            className="w-48 p-1 rounded-l-[2px] border border-grey-button [appearance:textfield] [&::-webkit-outer-spin-button]:appearance-none [&::-webkit-inner-spin-button]:appearance-none"
                            type="number"
                            placeholder="0"
                            {...register("pointReview")}
                            disabled={!isPointReview}
                          />
                          <div className="rounded-r-[2px] border border-grey-button p-1">
                            P
                          </div>
                        </div>
                      </div>
                    </div>
                  </FieldBox>
                </li>

                {/* Product input section */}
                <li className="mt-6">
                  <h2 className="font-bold text-[14px] mb-3">
                    3. 개별 상품 정보
                  </h2>
                  <FieldBox label="상품명">
                    <input
                      value={productName}
                      className="border rounded-[4px] w-full h-10 text-[10px] p-2"
                      placeholder="공백포함 65자 이내로 입력해주세요. (먼저 상품명, REF코드, 색상코드 등록 후, '+ 상품 리스트에 적용'을 눌러 추가해주세요.)"
                      onChange={(e) => handleChangeProduct(e, "name")}
                    />
                  </FieldBox>

                  <FieldBox label="REF(상품코드)">
                    <input
                      value={productRef}
                      className="border rounded-[4px] w-full h-10 text-[10px] p-2"
                      placeholder="상품코드(REF)를 입력해주세요. ONEDAY Mall에 등록되는 상품그룹명의 상품번호와 다르며, 개발 상품의 REF입니다."
                      onChange={(e) => handleChangeProduct(e, "ref")}
                    />
                  </FieldBox>

                  <FieldBox padding="p-0" label="색상코드" isLast>
                    <div className="flex gap-8 items-center p-2">
                      <div className="flex gap-1 items-center">
                        <input
                          checked={productColorStatus === "1"}
                          name="color"
                          type="radio"
                          value="1"
                          id="register_color"
                          className="flex-none accent-primary-black"
                          onChange={onChangeProductColorStatus}
                          disabled={
                            selectedCategory !==
                            "3db02ee9-47e8-4c2a-8cae-af8af80cad29"
                          }
                        />
                        <label htmlFor="register_color">등록</label>
                      </div>

                      <div className="flex gap-1 items-center ">
                        <input
                          checked={productColorStatus === "0"}
                          name="color"
                          type="radio"
                          value="0"
                          id="not_register_color"
                          className="flex-none accent-primary-black"
                          onChange={onChangeProductColorStatus}
                        />
                        <label htmlFor="not_register_color">등록안함</label>
                      </div>

                      <p className="text-[12px] text-[#ff0000]">
                        ※ Fixture 카테고리만 색상코드 등록 가능
                      </p>
                    </div>
                    {productColorStatus === "1" && (
                      <div className="flex divide-x">
                        <div className="flex gap-8 items-center border-t border-primary-grey p-2">
                          <div className="flex gap-2 items-center">
                            <span className="w-[2rem]">지름</span>
                            <select
                              onChange={(e) => handleChangeProduct(e, "width")}
                              className="text-[#333333] border border-button-grey border rounded-[4px] w-[140px] h-10 text-[10px] p-2 "
                            >
                              <option value={3.0}>3.0</option>
                              <option value={3.3}>3.3</option>
                              <option value={3.8}>3.8</option>
                              <option value={4.0}>4.0</option>
                              <option value={4.5}>4.5</option>
                              <option value={5.0}>5.0</option>
                              <option value={5.5}>5.5</option>
                              <option value={6.0}>6.0</option>
                              <option value={7.0}>7.0</option>
                            </select>
                          </div>
                          <div className="flex gap-2 items-center">
                            <span className="w-[2rem]">길이</span>
                            <select
                              onChange={(e) => handleChangeProduct(e, "length")}
                              className="text-[#333333] border border-button-grey border rounded-[4px] w-[140px] h-10 text-[10px] p-2"
                            >
                              {lengthOptions?.map((val) => (
                                <option key={val} value={val}>
                                  {val}
                                </option>
                              ))}
                            </select>
                            <button className="bg-primary-blue text-white h-10 rounded-[4px] w-16 mr-4">
                              등록
                            </button>
                          </div>
                        </div>
                        <div className="border-t border-primary-grey p-2 w-full">
                          <div className="flex p-4 gap-3 items-center">
                            <span>색상코드</span>
                            <input
                              type="color"
                              className="w-10 h-10 rounded-sm cursor-pointer"
                              onChange={(e) => handleChangeProduct(e, "color")}
                            />
                            <div className="bg-[#eeeeee] border border-[#dddddd] p-2 text-[#333333] rounded-[4px] w-32 h-10">
                              <div className="my-auto">
                                {entryProduct?.color?.toUpperCase()}
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    )}
                  </FieldBox>

                  <div className="w-full flex justify-center mt-4">
                    <button
                      disabled={!productFullFilled}
                      type="button"
                      onClick={(e) => handleAddProductItem(e)}
                      className={`
                      ${
                        !productFullFilled
                          ? "cursor-not-allowed  bg-[#dddddd] border border-[#cccccc] text-[#707070]"
                          : "bg-gradient-to-b from-white via-primary-white to-background-grey border border-button-grey"
                      } flex items-center w-[600px] justify-center w-20  text-[12px] py-1 rounded-[4px] h-8`}
                    >
                      <AiOutlinePlus className="mr-1" /> 상품 리스트에 적용
                    </button>
                  </div>

                  <div className="flex justify-center">
                    <ProductList
                      handleSelectProduct={handleSelectProduct}
                      handleDeleteProduct={(e) =>
                        handleDeleteProduct(e, selectedProducts)
                      }
                      selectedProducts={selectedProducts}
                      productList={productList}
                      selectAll={handleSelectAll}
                      handleChangeProductInsideTable={
                        handleChangeProductInsideTable
                      }
                    />
                  </div>
                </li>

                <li className="mt-6">
                  <h2 className="font-bold text-[14px] mb-3">
                    4. [공통] 상품 이미지
                  </h2>
                  <FieldBox
                    label={`대표 이미지 (${mainImage !== "" ? "1" : "0"}/1)`}
                  >
                    <div className="flex flex-wrap items-center p-2 gap-4">
                      <label
                        htmlFor="imageInput"
                        className={`${
                          mainImage !== ""
                            ? "cursor-not-allowed"
                            : " cursor-pointer"
                        }`}
                      >
                        <div
                          className={` w-[100px] h-[100px]  border border-[#cccccc]`}
                        >
                          <input
                            id="imageInput"
                            ref={mainImageRef}
                            type="file"
                            className="hidden"
                            onChange={handleImageUpload}
                            disabled={mainImage !== ""}
                          />
                          <AiOutlinePlus className="text-[#707070] m-auto my-auto h-full" />
                        </div>
                      </label>
                      {mainImage !== "" && (
                        <div className="relative w-[100px] h-[100px] border border-[#cccccc]">
                          <div
                            onClick={handleRemoveImage}
                            className=" absolute -right-0 text-white top-0 px-2 py-1 cursor-pointer bg-black opacity-50"
                          >
                            X
                          </div>
                          <div className="bg-[#f2dca8] text-[#0f1e3d] absolute left-0 top-0 px-2 py-1 cursor-pointer">
                            1
                          </div>
                          <img
                            src={mainImage}
                            className="object-cover w-full h-full"
                          />
                        </div>
                      )}
                    </div>
                  </FieldBox>
                  <FieldBox
                    label={`추가 이미지 (${
                      moreImages?.length > 0 ? moreImages?.length : "0"
                    }/7)`}
                    isLast
                  >
                    <div className="flex flex-wrap items-center p-2 gap-4">
                      <label
                        htmlFor="moreImageInput"
                        className={`${
                          moreImages?.length === 7
                            ? "cursor-not-allowed"
                            : " cursor-pointer"
                        }`}
                      >
                        <div
                          className={` w-[100px] h-[100px]  border border-[#cccccc]`}
                        >
                          <input
                            id="moreImageInput"
                            ref={moreImageRef}
                            type="file"
                            className="hidden"
                            onChange={handleMoreImageUpload}
                            disabled={moreImages?.length === 7}
                          />
                          <AiOutlinePlus className="text-[#707070] m-auto my-auto h-full" />
                        </div>
                      </label>
                      {moreImages?.slice(0, 7).map((val, index) => {
                        return (
                          <div
                            key={index}
                            className="relative w-[100px] h-[100px] border border-[#cccccc]"
                          >
                            <div
                              onClick={() => handleRemoveMoreImage(val)}
                              className=" absolute -right-0 text-white top-0 px-2 py-1 cursor-pointer bg-black opacity-50"
                            >
                              X
                            </div>
                            <div className="bg-[#f2dca8] text-[#0f1e3d] absolute left-0 top-0 px-2 py-1 cursor-pointer">
                              {index + 1}
                            </div>
                            <img
                              src={val}
                              className="object-cover w-full h-full"
                            />
                          </div>
                        );
                      })}
                    </div>
                  </FieldBox>
                </li>

                <li className="mt-6">
                  <h2 className="font-bold text-[14px] mb-3">
                    5. [공통] 상품 상세정보
                  </h2>
                  <Editor
                    ref={quillRef}
                    defaultValue={JSON.parse(defaultValues?.description)}
                    readOnly={false}
                  />
                </li>

                <li className="mt-6">
                  <h2 className="font-bold text-[14px] mb-3">6. [공통] 배송</h2>

                  <FieldBox label="배송비 부과여부">
                    <div className="flex gap-8 items-center">
                      <div className="flex gap-1 items-center">
                        <input
                          checked={deliveryTypeValue === "FREE"}
                          name="deliveryType"
                          type="radio"
                          value="FREE"
                          id="무료배송"
                          onChange={onChangeDeliveryType}
                          className="flex-none accent-primary-black"
                        />
                        <label htmlFor="무료배송">무료배송</label>
                      </div>

                      <div className="flex gap-1 items-center">
                        <input
                          checked={deliveryTypeValue === "PAID"}
                          name="deliveryType"
                          type="radio"
                          value="PAID"
                          id="배송비 부과"
                          onChange={onChangeDeliveryType}
                          className="flex-none accent-primary-black"
                        />
                        <label htmlFor="배송비 부과">배송비 부과</label>
                      </div>
                    </div>
                  </FieldBox>
                  <FieldBox label="배송비">
                    <div className="flex rounded-[4px]">
                      <input
                        className="w-48 p-1 rounded-l-[2px] border border-grey-button"
                        type="text"
                        placeholder="0"
                        disabled={deliveryTypeValue === "FREE"}
                        onChange={onChangeDeliveryFee}
                        value={formatPrice(deliveryFee)}
                      />

                      <div className="rounded-r-[2px] border border-grey-button p-1">
                        원
                      </div>
                    </div>
                  </FieldBox>
                  <FieldBox label="출고지">
                    <FieldInput
                      placeholder="출고지를 입력해주세요 (예- OOO본사 이하주소)"
                      registration={register("deliveryFromAddress")}
                    />
                  </FieldBox>

                  <FieldBox label="배송기간" isLast>
                    <FieldInput
                      placeholder="배송기간을 입력해주세요 (예-영업일로부터 2~3일 소요)"
                      registration={register("deliveryPeriod")}
                    />
                  </FieldBox>
                </li>

                <li className="mt-6">
                  <h2 className="font-bold text-[14px] mb-3">
                    7. [공통] 반품/교환
                  </h2>

                  <FieldBox label="배송비 부과여부">
                    <div className="flex gap-8 items-center">
                      <div className="flex gap-1 items-center">
                        <input
                          checked={refundTypeValue === "FREE"}
                          name="refundType"
                          type="radio"
                          value="FREE"
                          id="무료배송r"
                          onChange={onChangeRefundType}
                          className="flex-none accent-primary-black"
                        />
                        <label htmlFor="무료배송r">무료배송</label>
                      </div>

                      <div className="flex gap-1 items-center">
                        <input
                          checked={refundTypeValue === "PAID"}
                          name="refundType"
                          type="radio"
                          value="PAID"
                          id="배송비 부과r"
                          onChange={onChangeRefundType}
                          className="flex-none accent-primary-black"
                        />
                        <label htmlFor="배송비 부과r">배송비 부과</label>
                      </div>
                    </div>
                  </FieldBox>
                  <FieldBox label="반품배송비(편도)">
                    <div className="flex rounded-[4px]">
                      <input
                        className="w-48 p-1 rounded-l-[2px] border border-grey-button"
                        disabled={refundTypeValue === "FREE"}
                        type="text"
                        placeholder="0"
                        onChange={onChangeRefundPrice1}
                        value={formatPrice(refundPrice1)}
                      />
                      <div className="rounded-r-[2px] border border-grey-button p-1">
                        원
                      </div>
                    </div>
                  </FieldBox>

                  <FieldBox label="교환배송비(왕복)">
                    <div className="flex rounded-[4px]">
                      <input
                        className="w-48 p-1 rounded-l-[2px] border border-grey-button"
                        disabled={refundTypeValue === "FREE"}
                        type="text"
                        placeholder="0"
                        onChange={onChangeRefundPrice2}
                        value={formatPrice(refundPrice2)}
                      />
                      <div className="rounded-r-[2px] border border-grey-button p-1">
                        원
                      </div>
                    </div>
                  </FieldBox>

                  <FieldBox label="반품/교환지" isLast>
                    <FieldInput
                      placeholder="반품/교환지를 입력해주세요 (예- OOO본사 이하주소)"
                      registration={register("refundAddress")}
                    />
                  </FieldBox>
                </li>
              </ol>

              <div className="mt-24 flex justify-center gap-2 items-center">
                {/* <Modal
                  description={
                    <div>
                      상품 리스트의 해당 상품을 삭제하시겠습니까? <br />{" "}
                      선택삭제 할 경우, 삭제 데이터는 복구되지 않습니다.
                    </div>
                  }
                  onSubmit={handleDeleteProductGroup}
                >
                  <Button text="취소" />
                </Modal> */}
                <Modal
                  description="입력을 취소하시겠습니까? 입력한 정보는 저장되지 않습니다."
                  onSubmit={handleCancelEdit}
                >
                  <Button text="취소" />
                </Modal>
                <Modal
                  description={
                    <div>
                      입력한 정보로 변경을 완료하시겠습니까?
                      <br />
                      변경 된 정보로 병원 APP/WEB에 상품 판매정보가 업데이트
                      됩니다.
                    </div>
                  }
                  onSubmit={() => handleSubmitEdit(formValues)}
                >
                  <Button
                    type="button"
                    // onClick-={(e) => e.preventDefault()}
                    disabled={formEmpty}
                    isDisabled={formEmpty}
                    text="변경완료"
                    primary
                  />{" "}
                </Modal>
              </div>
            </>
          );
        }}
      </Form>
    </div>
  );
};

export default ProductGroupEditPage;
